(function () {'use strict';}());
angular.module("app").directive('loseView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'views/lose.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.$watch("currentPageIndex",onPageChange);

        function onPageChange(val){
        	if(val !== $scope.PAGE_LOSE) return;

        	$scope.objectsCollected = 0;

        	for(var j = 0, num = $scope.currentAdventure.periods.length; j < num; j++){
                var period = $scope.currentAdventure.periods[j];
                if(!period.artifacts) continue;
                $scope.objectsCollected += period.artifacts.length;
            }

            if($scope.objectsCollected === 0) $scope.objectsCollected = "0";
        }
      }  
    };
  });